import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TenantsService } from '../services/tenants.service';
import { SchedulerCacheService } from '../services/scheduler-cache.service';
import { Tenants } from '../enums/page-type.enum';
import { SelectionService } from '../services/selection.service';
import { TextHelper } from '../helpers/text.helper';

@Injectable({ providedIn: 'root' })
export class TenantGuard {
  private readonly tenantsService = inject(TenantsService);
  private readonly schedulerCacheService = inject(SchedulerCacheService);
  private readonly selectionService = inject(SelectionService);

  async canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
    await this.tenantsService.whenReady();
    await this.schedulerCacheService.whenReady();
    let tenantUrlName = route.params.tenantUrlName as string;
    if (tenantUrlName === Tenants.AllTenants) {
      if (this.tenantsService.tenants.length === 1) {
        tenantUrlName = this.tenantsService.tenants[0]
          ? TextHelper.getUrlNameFromLabel(this.tenantsService.tenants[0].label)
          : null;
      } else {
        tenantUrlName = null;
      }
    }
    this.selectionService.clear();
    this.tenantsService.selectTenantByUrlName(tenantUrlName);
    return true;
  }
}
